var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparkleAi = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.078 14.305a.523.523 0 0 1 .98 0l1.231 3.327a.523.523 0 0 0 .309.309l3.327 1.231a.523.523 0 0 1 0 .98l-3.327 1.232a.522.522 0 0 0-.309.308l-1.231 3.327a.523.523 0 0 1-.98 0l-1.232-3.327a.522.522 0 0 0-.308-.308l-3.327-1.232a.523.523 0 0 1 0-.98l3.327-1.231a.523.523 0 0 0 .308-.309l1.232-3.327ZM10.108 8.316a.418.418 0 0 1 .784 0l.959 2.591a.418.418 0 0 0 .247.248l2.592.959a.418.418 0 0 1 0 .784l-2.592.96a.418.418 0 0 0-.247.246l-.96 2.592a.418.418 0 0 1-.783 0l-.96-2.592a.418.418 0 0 0-.247-.247l-2.591-.959a.418.418 0 0 1 0-.784l2.591-.96a.418.418 0 0 0 .248-.246l.959-2.592ZM22.137 7.096a.314.314 0 0 1 .588 0l.688 1.856c.031.086.099.154.185.186l1.857.687a.314.314 0 0 1 0 .588l-1.857.687a.314.314 0 0 0-.185.186l-.688 1.856a.314.314 0 0 1-.588 0l-.687-1.856a.313.313 0 0 0-.185-.186l-1.857-.687a.314.314 0 0 1 0-.588l1.857-.687a.313.313 0 0 0 .185-.186l.687-1.856Z",
  fill: "#fff"
})));
export default SvgSparkleAi;